import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-banner-landing',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './banner-landing.component.html',
  styleUrl: './banner-landing.component.scss'
})
export class BannerLandingComponent {
  scrollTo(section: string) {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

